var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-view-sheet-field',{attrs:{"align":"center","demoted-icon":_vm.field.type,"is-sticky":_vm.isSticky,"is-demoted":_vm.isDemoted,"field":_vm.field,"filter":_vm.filter}},[(_vm.disparity < 0)?[_vm._v("-")]:_vm._e(),(_vm.disparity > 0)?[_vm._v("+")]:_vm._e(),_vm._v(_vm._s(_vm._f("round")(_vm._f("abs")(_vm.disparity),1, true))+" ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }